import { isString } from "lodash";
import { isArray, isLog, isLogBook, isStringEmpty } from "../utils/checkTool";
import request from ".";
import { Log, LogAdd, LogBook } from "../types/logBook";
import { cleanToLog, cleanToLogBook } from "../utils/cleanData";
import { CommonListParams } from "../types/common";

const url = "/wms/logBook";

const apis = {
  add: `${url}/add`,
  disable: (id: string) => `${url}/${id}/disable`,
  fetch: (id: string) => `${url}/${id}/fetch`,
  logAdd: (id: string) => `${url}/${id}/log/add`,
  logSubAdd: (id: string) => `${url}/log/${id}/sub/add`,
  logs: (id: string) => `/wms/logBook/${id}/logs`,
  logsFetch: (id: string) => `${url}/${id}/logs/fetch`,
};

export const logBookAdd = (name: string) => {
  if (!isString(name)) {
    return Promise.reject(10012);
  }
  return request<LogBook, string>(apis.add)
    .then(({ body: info }) => {
      if (isLogBook(info)) {
        return Promise.resolve(cleanToLogBook(info));
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

export const logBookDisable = (id: string) => {
  if (!isString(id) || isStringEmpty(id)) {
    return Promise.reject(10012);
  }
  return request<void>(apis.disable(id));
};

export const logBookFetch = (id: string) => {
  if (!isString(id) || isStringEmpty(id)) {
    return Promise.reject(10012);
  }
  return request<LogBook, string>(apis.fetch(id))
    .then(({ body: logBook }) => {
      if (isLogBook(logBook)) {
        return Promise.resolve(cleanToLogBook(logBook));
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

export const logBookAddLog = (id: string, log: LogAdd) => {
  if (
    !isString(id) ||
    isStringEmpty(id) ||
    (log.content && !isString(log.content)) ||
    (log.docId && !isString(log.docId))
  ) {
    return Promise.reject(10012);
  }
  return request<Log, LogAdd>(apis.logAdd(id), {
    params: { body: log },
  })
    .then(({ body: info }) => {
      return Promise.resolve(info)
    })
    .catch((err) => Promise.reject(err));
};

export const logBookAddSubLog = (id: string, log: LogAdd) => {
  if (
    !isString(id) ||
    isStringEmpty(id) ||
    (log.content && !isString(log.content)) ||
    (log.docId && !isString(log.docId))
  ) {
    return Promise.reject(10012);
  }
  return request<Log, LogAdd>(apis.logSubAdd(id), {
    params: { body: log },
  })
    .then(({ body: info }) => {
      return Promise.resolve(info);
    })
    .catch((err) => Promise.reject(err));
};

export const logBookLogs = (id: string, params?: CommonListParams) => {
  if (
    !isString(id) ||
    isStringEmpty(id) ||
    (params && params.body && !isString(params.body))
  ) {
    return Promise.reject(10012);
  }
  return request<Array<Log>, string>(apis.logs(id), { params })
    .then(({ body: logs, pagination }) => {
      if (isArray<Log>(logs)) {
        return Promise.resolve({
          logs: logs.filter((log) => isLog(log))?.map((log) => cleanToLog(log)),
          pagination
        });
      } else {
        return Promise.reject(10013);
      }
    })
    .catch((err) => Promise.reject(err));
};

export const logBookLogsFetch = (id: string, params?: CommonListParams<string>) => {
  return new Promise<CommonListParams<Array<Log>>>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id) || (params && params.body && !isString(params.body))) {
      return reject(10012);
    }
    request<Array<Log>, string>(apis.logsFetch(id), { params })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  })
};

const exportObject = {
  logBookAdd,
  logBookDisable,
  logBookFetch,
  logBookAddLog,
  logBookAddSubLog,
  logBookLogs,
  logBookLogsFetch,
};

export default exportObject;
